var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ooh_amap"}},[_c('div',{style:('height:'+_vm.height+'px'),attrs:{"id":"container"}}),(_vm.isSearch)?_c('div',{attrs:{"id":"myPageTop"}},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"id":"tipinput","placeholder":"请输入关键字，并选择地址"}})])
}]

export { render, staticRenderFns }